import { IMAGE_BLUR_PLACEHOLDERS } from '@/generated/imageBlurPlaceholders';
import Image, { type ImageProps } from 'next/image';
import { forwardRef } from 'react';

function getGeneratedBlurDataURL(src: ImageProps['src']) {
  if (typeof src !== 'string') {
    return 'blurDataURL' in src ? src.blurDataURL : undefined;
  }

  return IMAGE_BLUR_PLACEHOLDERS[src as keyof typeof IMAGE_BLUR_PLACEHOLDERS]
    ?.blurDataURL;
}

const BlurImage = forwardRef<HTMLImageElement, ImageProps>(function BlurImage(
  { alt, blurDataURL, placeholder, src, ...props },
  ref,
) {
  const resolvedBlurDataURL = blurDataURL ?? getGeneratedBlurDataURL(src);
  const resolvedPlaceholder =
    placeholder ?? (resolvedBlurDataURL ? 'blur' : 'empty');

  return (
    <Image
      {...props}
      ref={ref}
      alt={alt}
      src={src}
      placeholder={resolvedPlaceholder}
      blurDataURL={resolvedBlurDataURL}
    />
  );
});

BlurImage.displayName = 'BlurImage';

export default BlurImage;
